import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";
import {
  createStyles,
  DialogActions,
  DialogContent,
  makeStyles,
  useTheme,
} from "@material-ui/core";
import "jspdf-autotable";
import SettingsIcon from "@material-ui/icons/Settings";

import { CustomTheme } from "../../../../types/customTheme";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import {
  getLayout,
  updateLayout,
} from "../../../../services/insightApp/metrics";
import RGL, { WidthProvider, Layout } from "react-grid-layout";
import SingleWidgetBox from "./SingleWidgetBox";
import { SUCCESSFULLY_UPDATED } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import WidgetSelectModal from "./WidgetSelectModal";
import WidgetTitleEditRemoveModal from "./WidgetTitleEditRemoveModal";
import AlertDialog from "../../../../components/alerts/AlertDialog";
import TextWidgetBox from "./TextWidgetBox";
import WidgetTitleSubtitleEditRemoveModal from "./WidgetTitleSubtitleEditRemoveModal";
import EmptyWidgetBoxes from "./EmptyWidgetBoxes";

const ReactGridLayout = WidthProvider(RGL);

const baseWidgetsList = [
  {
    key: "0",
    keyProps: "locationAverageTime",
    label: "Location Average Time",
    labelInitial: "Location Average Time",
    main: "Core",
    path: ["locationAverageTime", "total"],
  },
  {
    key: "1",
    keyProps: "loadAverageTime",
    label: "Load Average Time",
    labelInitial: "Load Average Time",
    main: "Core",
    path: ["loadAverageTime"],
  },
  {
    key: "2",
    keyProps: "preparationAverageTime",
    label: "Preparation Average Time",
    labelInitial: "Preparation Average Time",
    main: "Core",
    path: ["preparationAverageTime"],
  },
  {
    key: "3",
    keyProps: "deliveryAverageTime",
    label: "Delivery Average Time",
    labelInitial: "Delivery Average Time",
    main: "Core",
    path: ["deliveryAverageTime"],
  },
  {
    key: "4",
    keyProps: "eatpresto",
    label: "Eatpresto",
    main: "Channel",
    labelInitial: "Eatpresto",
    path: ["locationAverageTime", "channel", "eatpresto"],
  },
  {
    key: "5",
    keyProps: "deliverect",
    label: "Deliverect",
    labelInitial: "Deliverect",
    main: "Channel",
    path: ["locationAverageTime", "channel", "deliverect"],
  },
  {
    key: "6",
    keyProps: "justeat",
    label: "Justeat",
    labelInitial: "Justeat",
    main: "Channel",
    path: ["locationAverageTime", "channel", "justeat"],
  },
  {
    key: "7",
    keyProps: "deliveroo",
    label: "Deliveroo",
    labelInitial: "Deliveroo",
    main: "Channel",
    path: ["locationAverageTime", "channel", "deliveroo"],
  },
  {
    key: "8",
    keyProps: "Ubereats",
    label: "Ubereats",
    labelInitial: "Ubereats",
    main: "Channel",
    path: ["locationAverageTime", "channel", "ubereats"],
  },
  {
    key: "9",
    keyProps: "walkIn",
    label: "Walk In",
    labelInitial: "Walk In",
    main: "Mode",
    path: ["locationAverageTime", "mode", "walk_in"],
  },
  {
    key: "10",
    keyProps: "collection",
    label: "Collection",
    labelInitial: "Collection",
    main: "Mode",
    path: ["locationAverageTime", "mode", "collection"],
  },
  {
    key: "11",
    keyProps: "delivery",
    label: "Delivery",
    labelInitial: "Delivery",
    main: "Mode",
    path: ["locationAverageTime", "mode", "delivery"],
  },
  {
    key: "12",
    keyProps: "dineIn",
    label: "Dine In",
    labelInitial: "Dine In",
    main: "Mode",
    path: ["locationAverageTime", "mode", "dine_in"],
  },
  {
    key: "13",
    keyProps: "futureTable",
    label: "Future Table",
    labelInitial: "Future Table",
    main: "Mode",
    path: ["locationAverageTime", "mode", "future_table"],
  },
  {
    key: "14",
    keyProps: "walkIn",
    label: "Walk In",
    labelInitial: "Walk In",
    main: "Platform",
    path: ["locationAverageTime", "platform", "walk in"],
  },
  {
    key: "15",
    keyProps: "Phone",
    label: "Phone",
    labelInitial: "Phone",
    main: "Platform",
    path: ["locationAverageTime", "platform", "phone"],
  },
  {
    key: "16",
    keyProps: "kiosk",
    label: "Kiosk",
    labelInitial: "Kiosk",
    main: "Platform",
    path: ["locationAverageTime", "platform", "kiosk"],
  },
  {
    key: "17",
    keyProps: "online",
    label: "Online",
    labelInitial: "Online",
    main: "Platform",
    path: ["locationAverageTime", "platform", "online"],
  },
  {
    key: "18",
    keyProps: "stationAverageTime",
    label: "station Average Time",
    labelInitial: "station Average Time",
    main: "Core",
    path: ["stationAverageTime"],
  },
];

export interface DashboardCreateModalProps {
  open: any;
  setOpen: any;
  stationNode: any;
  setIsOpenWidgetSelectionModal: any;
  isOpenWidgetSelectionModal: any;
  dashboardName: any;
  widgetId: any;
  editDetails: any;
  setEditDetails: any;
  setLayoutDetails: any;
  setDashboardName: any;
  handleOpenConfigDetails: any;
  selectedWarningType: any;
  selectedCriticalType: any;
  configDetails: any;
  isDarkMode: any;
  clientId: any;
  selectedLocationId: any;
  locationSelectorList: any;
  setSelectedLocationId: any;
  isDraggable?: boolean;
  isResizable?: boolean;
  onLayoutChange?: (layout: Layout[]) => void;
}

const WidgetDetailsModal: React.FunctionComponent<
  DashboardCreateModalProps
> = ({
  open,
  setOpen,
  stationNode,
  isDraggable = true,
  isResizable = true,
  dashboardName,
  widgetId,
  setEditDetails,
  setLayoutDetails,
  handleOpenConfigDetails,
  selectedWarningType,
  selectedCriticalType,
  configDetails,
  onLayoutChange = () => {},
  setIsOpenWidgetSelectionModal,
  isOpenWidgetSelectionModal,
  editDetails,
  setDashboardName,
  isDarkMode,
  clientId,
  selectedLocationId,
  locationSelectorList,
  setSelectedLocationId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDeleteConfirmationModal, setIsOpenDeleteConfirmationModal] =
    useState(false);
  const [error, setError] = useState("");
  const [isOpenEditModal, setsOpenEditModal] = useState(false);
  const [isOpenTextEditModal, setIsOpenTextEditModal] = useState(false);
  const [allWidgets, setAllWidgets] = useState<any[]>(baseWidgetsList);
  const [editableWidget, setEditableWidget] = useState<any>({});
  const [layout, setLayout] = useState<Layout[]>([]);
  const [success, setSuccess] = useState("");
  const [selectedWidgets, setSelectedWidgets] = useState<any[]>([]);

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  useEffect(() => {
    if (open) {
      const cloneLayout = _.cloneDeep(editDetails?.data || []);

      const dataList = cloneLayout
        .filter((item: any) => item.data) // only those with a data object
        .map((item: any) => item.data);
      setLayout(cloneLayout);
      setSelectedWidgets(dataList);
    } else {
      setLayout([]);
      setSelectedWidgets([]);
    }
  }, [open]);

  useEffect(() => {
    if (Object.keys(stationNode).length > 0) {
      const firstStation: any = Object.values(stationNode)[0];
      const updatedBaseWidgets = baseWidgetsList.map((widget) => {
        if (widget.key === "18") {
          return {
            ...widget,
            keyProps: firstStation?.name || "",
            label: firstStation?.name || "",
            labelInitial: firstStation?.name || "",
            path: ["stationAverageTime", firstStation.code],
          };
        }
        return widget;
      });

      Object.values(stationNode).map((item: any, index: number) => {
        updatedBaseWidgets.push({
          key: `${index + 18}`,
          main: "StationAverageTime",
          keyProps: item?.name || "",
          label: item?.name || "",
          labelInitial: item?.name || "",
          path: ["stationAverageTime", item.code],
        });
      });

      // const updatedBaseWidgets = baseWidgetsList.map((widget) => {
      //   if (widget.key === "4") {
      //     return {
      //       ...widget,
      //       keyProps: firstStation?.name || "",
      //       label: firstStation?.name || "",
      //       labelInitial: firstStation?.name || "",
      //       path: ["stationAverageTime", firstStation.code],
      //     };
      //   }
      //   return widget;
      // });
      setAllWidgets(updatedBaseWidgets);
    }
  }, [stationNode]);

  const handleLayoutChange = (newLayout: Layout[]) => {
    // setLayout(newLayout);

    const abc = newLayout.flatMap((w: any) => {
      const matchedWidgets = selectedWidgets.filter(
        (w1: any) => w.i === w1.key,
      );
      return matchedWidgets.map((matchedWidget) => ({
        h: w.h,
        i: w.i,
        w: w.w,
        x: w.x,
        y: w.y,
        data: matchedWidget,
      }));
    });
    onLayoutChange(abc);
    setLayout(abc);
  };

  const handleResize = useCallback(
    (_layout, _oldItem, layoutItem, placeholder) => {
      // Enforce min width of 1
      if (layoutItem.w < 1) {
        layoutItem.w = 1;
        placeholder.w = 1;
      }

      // Enforce max width of 6
      if (layoutItem.w > 12) {
        layoutItem.w = 12;
        placeholder.w = 12;
      }
    },
    [],
  );

  const getLayoutInfo = async () => {
    try {
      // Retrieve the idToken from cookies
      // Fetch all locations using the idToken
      const res = await getLayout(locationId);
      setLayoutDetails(res.data.data);
      setIsLoading(false);
      setOpen(false);
      setEditDetails({});
      setDashboardName("");

      //   if (res?.data?.data?.clientId) {
      //     const clientIdFromApi = res.data.data.clientId;
      //     setClientId(clientIdFromApi);
      //   }
    } catch (error) {}
  };

  const saveLayoutToFirebase = async () => {
    const data = {
      name: dashboardName,
      data: layout,
      config: {
        criticalType: selectedCriticalType.id,
        warningType: selectedWarningType.id,
        isDarkMode,
      },
    };
    try {
      const res = await updateLayout(locationId, data, widgetId);
      setSuccess(SUCCESSFULLY_UPDATED);

      getLayoutInfo();
    } catch (error) {
      console.error("Error saving layout:", error);
    }
  };
  const handleClick = () => {
    setIsLoading(true);
    saveLayoutToFirebase();
  };

  const handleClickAddWidget = () => {
    setIsOpenWidgetSelectionModal(true);
  };

  const handleDelete = () => {
    const COLS = 12; // Adjust according to your layout
    const cloneLayout = _.cloneDeep(layout);

    // Step 1: Remove the widget
    const newLayout = cloneLayout.filter(
      (item: any) => item.i !== editableWidget.key,
    );

    // Step 2: Sort by y then x
    const sorted = newLayout.sort((a: any, b: any) => {
      if (a.y === b.y) return a.x - b.x;
      return a.y - b.y;
    });

    // Step 3: Track occupied grid cells
    const occupied: { [x: number]: Set<number> } = {};
    for (let x = 0; x < COLS; x++) {
      occupied[x] = new Set<number>();
    }

    const reflowedLayout: any[] = [];

    sorted.forEach((item: any) => {
      const w = item.w || 1;
      const h = item.h || 1;
      let placed = false;

      // Try to place the widget at the first available (x, y)
      for (let y = 0; y < 100 && !placed; y++) {
        for (let x = 0; x <= COLS - w && !placed; x++) {
          let fits = true;

          // Check if the space is free
          for (let dx = 0; dx < w; dx++) {
            for (let dy = 0; dy < h; dy++) {
              if (occupied[x + dx]?.has(y + dy)) {
                fits = false;
                break;
              }
            }
          }

          if (fits) {
            // Mark the space as occupied
            for (let dx = 0; dx < w; dx++) {
              for (let dy = 0; dy < h; dy++) {
                occupied[x + dx].add(y + dy);
              }
            }

            reflowedLayout.push({
              ...item,
              x,
              y,
            });
            placed = true;
          }
        }
      }
    });

    // Step 4: Update selected widgets and layout
    const dataList = reflowedLayout
      .filter((item: any) => item.data)
      .map((item: any) => item.data);

    setLayout(reflowedLayout);
    setSelectedWidgets(dataList);
    setIsOpenDeleteConfirmationModal(false);
  };
  const theme: CustomTheme = useTheme();
  return (
    <>
      <DialogCommonDefault
        open={open}
        setOpen={setOpen}
        maxWidth={"xl"}
        isNeedFixedHeight={true}
      >
        <DialogContent>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <ButtonCommon
              color="green"
              onClick={handleClickAddWidget}
              style={{
                marginLeft: "12px",
                width: "160px",
                textTransform: "none",
                border: `1px solid ${theme.palette.background.entity_border}`,
              }}
            >
              Add Widget
            </ButtonCommon>
            <ButtonCommon
              color="yellow"
              onClick={handleOpenConfigDetails}
              style={{
                marginLeft: "12px",
                width: "40px",
                textTransform: "none",
                border: `1px solid ${theme.palette.background.entity_border}`,
              }}
            >
              <SettingsIcon />
            </ButtonCommon>
          </div>

          <ReactGridLayout
            isDraggable={isDraggable}
            isResizable={isResizable}
            rowHeight={120}
            cols={12}
            layout={layout}
            style={{ marginTop: "20px", zIndex: 0 }}
            onLayoutChange={handleLayoutChange}
            onResize={handleResize}
            autoSize
            draggableCancel=".no-drag"
          >
            {layout &&
              layout.map((data: any) => {
                if (
                  data?.data?.main !== "headBox" &&
                  data?.data?.main !== "headNormal" &&
                  data?.data?.main !== "spacer"
                ) {
                  return (
                    <div key={data?.data.key}>
                      <SingleWidgetBox
                        id={data?.data.key}
                        setLayout={setLayout}
                        layout={layout}
                        widgetData={data?.data}
                        setsOpenEditModal={setsOpenEditModal}
                        setEditableWidget={setEditableWidget}
                        setSelectedWidgets={setSelectedWidgets}
                        setIsOpenDeleteConfirmationModal={
                          setIsOpenDeleteConfirmationModal
                        }
                        configDetails={configDetails}
                        clientId={clientId}
                        selectedWidgets={selectedWidgets}
                      />
                    </div>
                  );
                } else if (data?.data?.main === "spacer") {
                  return (
                    <div key={data?.data.key}>
                      <EmptyWidgetBoxes
                        widgetData={data}
                        setEditableWidget={setEditableWidget}
                        setIsOpenDeleteConfirmationModal={
                          setIsOpenDeleteConfirmationModal
                        }
                      />
                    </div>
                  );
                } else {
                  return (
                    <div key={data?.data.key}>
                      <TextWidgetBox
                        widgetData={data}
                        setIsOpenTextEditModal={setIsOpenTextEditModal}
                        setEditableWidget={setEditableWidget}
                        setIsOpenDeleteConfirmationModal={
                          setIsOpenDeleteConfirmationModal
                        }
                        layout={layout}
                        setLayout={setLayout}
                        setSelectedWidgets={setSelectedWidgets}
                        id={data?.data?.key}
                        selectedWidgets={selectedWidgets}
                      />
                    </div>
                  );
                }
              })}
          </ReactGridLayout>
        </DialogContent>
        <DialogActions style={{ marginBottom: "12px", marginRight: "27px" }}>
          <ButtonCommon
            style={{ width: "120px" }}
            onClick={() => {
              setEditDetails({});
              setDashboardName("");
              setOpen(false);
            }}
          >
            Cancel
          </ButtonCommon>
          <ButtonCommon
            style={{ width: "120px" }}
            isLoadingPage={isLoading}
            onClick={handleClick}
            color="green"
          >
            Save
          </ButtonCommon>
        </DialogActions>
      </DialogCommonDefault>
      <DefaultAlert
        open={!!success}
        handleClose={() => setSuccess("")}
        message={success}
        severity={"success"}
      />

      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />

      <WidgetSelectModal
        open={isOpenWidgetSelectionModal}
        setOpen={setIsOpenWidgetSelectionModal}
        allWidgets={allWidgets}
        layout={layout}
        selectedWidgets={selectedWidgets}
        setSelectedWidgets={setSelectedWidgets}
        setLayout={setLayout}
        stationNode={stationNode}
      />

      <WidgetTitleEditRemoveModal
        open={isOpenEditModal}
        setOpen={setsOpenEditModal}
        layout={layout}
        setLayout={setLayout}
        editableWidget={editableWidget}
        setSelectedWidgets={setSelectedWidgets}
        locationSelectorList={locationSelectorList}
        selectedLocationId={selectedLocationId}
        setSelectedLocationId={setSelectedLocationId}
        selectedWidgets={selectedWidgets}
      />

      <WidgetTitleSubtitleEditRemoveModal
        open={isOpenTextEditModal}
        setOpen={setIsOpenTextEditModal}
        layout={layout}
        setLayout={setLayout}
        editableWidget={editableWidget}
        setSelectedWidgets={setSelectedWidgets}
        selectedWidgets={selectedWidgets}
      />

      <AlertDialog
        open={isOpenDeleteConfirmationModal}
        title="Warning"
        desc={"Are you sure do you need to delete this widget?"}
        severity="warning"
        confirmLabel="Ok"
        cancelLabel={"Cancel"}
        disableBackdropClick
        cancelAction={() => setIsOpenDeleteConfirmationModal(false)}
        confirmAction={handleDelete}
        color="secondary"
      />
    </>
  );
};

export default WidgetDetailsModal;
